module.exports = __webpack_public_path__ + "a70b838378c899fec840ad34ce0ddd6d.svg";